// production setting - comment line to get logs back
console.log = function() {}

import Nav from './tools/Nav.js';
import Motion from './tools/Motion.js';
import Menu from './tools/Menu.js';
import Home from './tools/Home.js';
import Pepzine from './tools/Pepzine.js';
//import Blog from './tools/Blog.js';
import Realisations from './tools/Realisations.js';
import Realisation from './tools/Realisation.js';
import Butchers from './tools/filters/Butchers.js';
import Bakers from './tools/filters/Bakers.js';
import Cheese from './tools/filters/Bakers.js';
import Restaurants from './tools/filters/Restaurants.js';
import Wine from './tools/filters/Wine.js';
import Others from './tools/filters/Others.js';

import { TweenMax, TweenLite, CSSPlugin } from 'gsap';


class Peps {


  /**
   * Constructor
   */
  constructor(){

    // Properties
    this.nav = new Nav;
    this.motion = new Motion;
    this.menu = new Menu;

    this.loadedListener;

    this.init();

  }


  /**
   * Init all behaviors on initial page load
  */

  init() {

    //console.log('force scrollTop');
    //window.scroll(0,0);
    //this.motion.disableScroll();

    this.initGlobalTemplateListeners();



    if (this.nav.currentPageId){
      console.log('page is ' + this.nav.currentPageId);
      /*
      if(this.nav.currentPageId == "pepzine-page-container") {
        console.log('set pepzine page');
        this.nav.page = new Pepzine(this.nav.currentPageId);
        this.nav.page.init();
        this.nav.page.setEventsListeners();
      }

      if(this.nav.currentPageId == "home-page-container") {
        console.log('set home page');
        this.nav.page = new Home(this.nav.currentPageId);
        this.nav.page.init();
        this.nav.page.setEventsListeners();
      }

      if(this.nav.currentPageId == "realisations-page-container") {
        console.log('set realisations page');
        this.nav.page = new Realisations(this.nav.currentPageId);
        this.nav.page.init();
        this.nav.page.setEventsListeners();
      }*/


      //ancien code pour la gestion des transitions entre les pages
      switch(this.nav.currentPageId) {
        case "home-page-container":
          console.log('set home page');
          this.nav.page = new Home(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "pepzine-page-container":
          console.log('set pepzine page');
          this.nav.page = new Pepzine(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        /*
        case "blog-page-container":
          console.log('set blog page');
          this.nav.page = new Blog(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;*/
        case "realisations-page-container":
          console.log('set realisations page');
          this.nav.page = new Realisations(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "realisation-page-container":
          console.log('set realisation page');
          this.nav.page = new Realisation(this.nav.currentPageId);
          this.nav.page.init();
          //this.nav.page.setEventsListeners();
          break;
        case "realisationsFilterButchers-page-container":
          console.log('set realisations butchers page');
          this.nav.page = new Butchers(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "realisationsFilterBakers-page-container":
          console.log('set realisations bakers page');
          this.nav.page = new Bakers(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "realisationsFilterCheese-page-container":
          console.log('set realisations cheese page');
          this.nav.page = new Cheese(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "realisationsFilterRestaurants-page-container":
          console.log('set realisations restaurants page');
          this.nav.page = new Restaurants(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "realisationsFilterWine-page-container":
          console.log('set realisations wine page');
          this.nav.page = new Wine(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        case "realisationsFilterOthers-page-container":
          console.log('set realisations others page');
          this.nav.page = new Others(this.nav.currentPageId);
          this.nav.page.init();
          this.nav.page.setEventsListeners();
          break;
        default:
          console.log('no page set');
      }

    }
    /*
    // animations
    switch(this.nav.currentPageId) {
      case "home-page-container":
        this.motion.animateHome();
        break;
      default:
        this.motion.animateRemove();
    }*/

  }



  /**
   * Init
   */
  initGlobalTemplateListeners() {
    if (window.innerWidth < 1024 && this.menu.open == true){
      this.menu.toggle(this.menu.toggler);
    }
    /*
    window.addEventListener(
      'lock_screen',
      this.lockScreen.bind(this),
      false
    );
    window.addEventListener(
      'unlock_screen',
      this.unlockScreen.bind(this),
      false
    );
    window.addEventListener(
      'lock_filter',
      this.lockFilter.bind(this),
      false
    );
    window.addEventListener(
      'unlock_filter',
      this.unlockFilter.bind(this),
    );*/
    /*
    document.getElementById("site-logo").addEventListener('click',
      function(e){
        if(this.nav.currentPageId == "blog-page-container") {
          return;
        }
        else if(document.body.classList.contains("single-format-standard")) {
          return;
        }
        else if(document.body.classList.contains("single-clients")) {
          return;
        }
        else if(document.body.classList.contains("single-heroes")) {
          return;
        }
        else if(document.body.classList.contains("single-coulisses")) {
          return;
        }
        else if(document.body.classList.contains("single-zooms")) {
          return;
        }
        else {
          e.preventDefault();
          console.log('logo event');
        }
        // toggle menu if mobile display
        if (window.innerWidth < 1024 && this.menu.open == true){
          this.menu.toggle(this.menu.toggler);
        }
        if(this.nav.currentPageId != "home-page-container"){
          this.nav.navigation("home-page-container");
        } else {
          console.log('do nothing');
        }
      }.bind(this)
    );
    */

    if(document.getElementById("site-nav")){
      /*
      console.log('menu event');
      var that = this; // no bind here, need (this)
      var menuAnchors = document
        .getElementById("site-nav").getElementsByTagName('a');
      for(var i=0, len=menuAnchors.length; i<len; i++){
        menuAnchors[i].addEventListener('click',
          function(e){
            if(document.body.classList.contains("single-format-standard")) {
              return;
            }
            else if(document.body.classList.contains("single-clients")) {
              return;
            }
            else if(document.body.classList.contains("single-heroes")) {
              return;
            }
            else if(document.body.classList.contains("single-coulisses")) {
              return;
            }
            else if(document.body.classList.contains("single-zooms")) {
              return;
            }
            else {
              e.preventDefault();
            }
            var parts = this.href.split('/');
            var slug = parts[parts.length - 1];
            var current = that.nav.currentPageId.split('-')[0];
            // toggle menu if mobile display
            if (window.innerWidth < 1024){
              that.menu.toggle(that.menu.toggler);
            }
            if (current != slug){
              switch(slug) {
                case "realisations":
                  that.nav.navigation("realisations-page-container");
                  break;
                case "pepzine":
                  that.nav.navigation("pepzine-page-container");
                  break;
                case "blog":
                  that.nav.navigation("blog-page-container");
                  break;
                case "contact":
                  that.contactNavigation();
                  break;
                default:
                  console.log('untracked navigation: ' + slug);
                  if (this.target !== "_blank") {
                    window.location.href = this.href;
                  } else {
                    window.open(this.href);
                  }
              }
            } else {
              console.log('already on page ' + slug + ' do nothing');
            }
          }
        );
      }*/
      this.motion.initBorders();
    }
  }


  /**
   * Lock screen
   */
  lockScreen(){
    console.log('PASS LOCK SCREEN');
    this.motion.displayLockingMask();
    this.motion.animatePageRemoval();
  }


  /**
   * Unlock screen
   */
  unlockScreen(){
    console.log('PASS UNLOCK SCREEN');
    this.motion.hideLockingMask();
    this.motion.animatePageAddition();
    this.motion.refreshBordersListeners();
  }


  /**
   * Lock filter
   */
  lockFilter(){
    console.log('--- PASS LOCK FILTER');
    this.motion.animateFilterLock();
  }


  /**
   * Unlock filter
   */
  unlockFilter(){
    console.log('--- PASS UNLOCK FILTER');
    this.motion.animateFilterUnlock();
  }


  /**
   * Contact navigation
   */
  contactNavigation(){
    if(this.nav.currentPageId == "home-page-container"){
      this.nav.page.goToContact();
    } else {
      this.nav.navigation("contact-page-container");
    }
  }


}

export default Peps;
